const getThemeColor = color => ({ theme: { carvana } }) => carvana[color];
const getColorVariant = color => variant => ({ theme: { carvana } }) =>
  carvana[color][variant];

const getBreakpointValue = size => ({
  theme: {
    breakpoints: { values }
  }
}) => values[size];

const cvTypography = attr => ({ theme: { typography } }) => typography[attr];

const cvGray = getColorVariant('gray');
const cvRed = getColorVariant('red');
const cvWhite = getColorVariant('white');
const cvBlue = getColorVariant('blue');
const cvGreen = getColorVariant('green');
const cvYellow = getColorVariant('yellow');
const cvStroke = getColorVariant('stroke');
const cvBody = getThemeColor('body');
const cvImpersonationRed = getThemeColor('impersonationRed');

const cvFontFamily = cvTypography('fontFamily');
const cvFontSize = cvTypography('fontSize');

const cvBreakpoint0 = getBreakpointValue('xs');
const cvBreakpoint768 = getBreakpointValue('sm');
const cvBreakpoint1024 = getBreakpointValue('md');
const cvBreakpoint1280 = getBreakpointValue('lg');
const cvBreakpoint1920 = getBreakpointValue('xl');

export {
  cvGray,
  cvRed,
  cvWhite,
  cvBlue,
  cvYellow,
  cvGreen,
  cvStroke,
  cvBody,
  cvImpersonationRed,
  cvFontFamily,
  cvFontSize,
  cvBreakpoint0,
  cvBreakpoint768,
  cvBreakpoint1024,
  cvBreakpoint1280,
  cvBreakpoint1920,
  cvTypography
};
